import {
	createContext,
	useCallback,
	useContext,
	useEffect,
	useState,
} from "react"
import { useLocation, useNavigate } from "react-router-dom"
// import { api } from "../../services/api";

const AuthContext = createContext()

export const useAuth = () => useContext(AuthContext)

const LISTA_MAYORISTA = 6

export const AuthProvider = ({
	defaultValue = { clientPriceListId: LISTA_MAYORISTA },
	children,
}) => {
	const [userData, setUserData] = useState(defaultValue)
	const [auth, setAuth] = useState(false)
	const navigate = useNavigate()
	const location = useLocation()

	const signIn = useCallback(
		(newUser) => {
			if (!auth) {
				window.localStorage.setItem("userMonaco", JSON.stringify(newUser))
				setUserData(newUser)
				setAuth((auth) => !auth)

				if (location.state?.from) {
					navigate(location?.state?.from, { replace: true })
				}
			}
		},
		[auth, location.state?.from, navigate],
	)

	const signOut = () => {
		window.localStorage.removeItem("userMonaco")
		setUserData(defaultValue)
		setAuth((auth) => !auth)
		navigate("/")
	}

	// const getUserData = async () => {
	// 	console.log("updeteando");
	// 	try {
	// 		const response = await api.account.getUserData(userData.clientDocNumber);
	// 		const updateUserData = await response.json();
	// 		console.log("updateUserData", updateUserData);
	// 		setUserData(updateUserData);
	// 	} catch (error) {
	// 		return;
	// 	}
	// };

	useEffect(() => {
		const loggedUserMonaco = window.localStorage.getItem("userMonaco")
		if (loggedUserMonaco) {
			signIn(JSON.parse(loggedUserMonaco))
		}
	}, [signIn])

	return (
		<AuthContext.Provider
			value={{
				userData,
				setUserData,
				auth,
				signIn,
				signOut,
				// getUserData,
			}}
		>
			{children}
		</AuthContext.Provider>
	)
}
